﻿import { VOID } from 'ol/functions.js';

let withCredentials = false;

export function loadFeaturesXhr(
    url,
    format,
    extent,
    resolution,
    projection,
    success,
    failure
) {
    const xhr = new XMLHttpRequest();
    xhr.open(
        'GET',
        typeof url === 'function' ? url(extent, resolution, projection) : url,
        true
    );
    if (format.getType() == 'arraybuffer') {
        xhr.responseType = 'arraybuffer';
    }
    xhr.withCredentials = withCredentials;

    xhr.onload = function (event) {
        if (!xhr.status || (xhr.status >= 200 && xhr.status < 300)) {
            const type = format.getType();
            let source;
            if (type == 'json' || type == 'text') {
                if (xhr.responseText.startsWith('<?xml ') && xhr.responseXML != null && xhr.responseXML.documentElement != null && xhr.responseXML.documentElement.nodeName == "ServiceExceptionReport") {
                    toastr.error(xhr.responseXML.documentElement.textContent);
                    return;
                }
                else {
                    source = xhr.responseText;
                }
            } else if (type == 'xml') {
                source = xhr.responseXML;
                if (!source) {
                    source = new DOMParser().parseFromString(
                        xhr.responseText,
                        'application/xml'
                    );
                }
            } else if (type == 'arraybuffer') {
                source = (xhr.response);
            }
            if (source) {
                success(
                    (
                        format.readFeatures(source, {
                            extent: extent,
                            featureProjection: projection,
                        })
                    ),
                    format.readProjection(source)
                );
            } else {
                failure();
            }
        } else {
            failure();
        }
    };
    xhr.onerror = failure;
    xhr.send();
}

export function xhr(url, format) {
    return function (extent, resolution, projection, success, failure) {
        const source = (this);
        loadFeaturesXhr(
            url,
            format,
            extent,
            resolution,
            projection,
            function (features, dataProjection) {
                source.clear(true);
                source.addFeatures(features);
                if (success !== undefined) {
                    success(features);
                }
            },
            failure ? failure : VOID
        );
    };
}

export function setWithCredentials(xhrWithCredentials) {
    withCredentials = xhrWithCredentials;
}
